import React, { FC, MouseEvent } from 'react'
import { UploadIcon } from '@heroicons/react/outline'
import { ReactComponent as FacebookIcon } from './svg/facebook.svg'
import { ReactComponent as TwitterIcon } from './svg/twitter.svg'
import { ReactComponent as LinkedInIcon } from './svg/linkedIn.svg'
import { CopyButton, Button } from '../../System'
import { StyledShareOptions } from '.'

type Props = {
  shareURL: string;
  onShare?: (type: string) => void;
}

const ShareOptions: FC<Props> = ({ shareURL, onShare }) => {
  const handleShare = (type: string, e?: MouseEvent) => {
    e?.stopPropagation()

    if (onShare) {
      onShare(type)
    }
  }

  return (
    <StyledShareOptions onClick={(e) => e.preventDefault()}>
      <Button theme="ghost" type="small" className="share-btn">
        <UploadIcon />
        <span>Share</span>
      </Button>
      <div className="share-tooltip">
        <div className="share-tooltip-content">
          <a
            href={`https://twitter.com/intent/tweet?url=${shareURL}&via=socialcurators`}
            target="_blank"
            onClick={(e) => handleShare('twitter', e)}
            rel="noreferrer noopener"
          >
            <TwitterIcon />
          </a>
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareURL}`}
            target="_blank"
            onClick={(e) => handleShare('linkedin', e)}
            rel="noreferrer noopener"
          >
            <LinkedInIcon />
          </a>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${shareURL}`}
            target="_blank"
            onClick={(e) => handleShare('facebook', e)}
            rel="noreferrer noopener"
          >
            <FacebookIcon />
          </a>
          <CopyButton copyContent={shareURL} plaintext onClick={() => handleShare('clipboard')} />
        </div>
      </div>
    </StyledShareOptions>
  )
}

export default ShareOptions
